// Generated by Ktorfit
@file:Suppress("warnings")

package org.mifos.mobile.core.network.services

import de.jensklingenberg.ktorfit.Ktorfit
import de.jensklingenberg.ktorfit.`internal`.ClassProvider
import de.jensklingenberg.ktorfit.`internal`.InternalKtorfitApi
import de.jensklingenberg.ktorfit.`internal`.KtorfitConverterHelper
import de.jensklingenberg.ktorfit.annotationsAttributeKey
import de.jensklingenberg.ktorfit.converter.TypeData
import io.ktor.client.request.HttpRequestBuilder
import io.ktor.client.request.parameter
import io.ktor.client.request.setBody
import io.ktor.client.statement.HttpResponse
import io.ktor.http.HttpMethod
import io.ktor.http.URLBuilder
import io.ktor.http.decodeURLQueryComponent
import io.ktor.http.encodeURLPath
import io.ktor.http.takeFrom
import io.ktor.util.reflect.typeInfo
import kotlin.Long
import kotlin.OptIn
import kotlin.String
import kotlin.Suppress
import kotlinx.coroutines.flow.Flow
import org.mifos.mobile.core.model.entity.TransactionDetails
import org.mifos.mobile.core.model.entity.accounts.savings.SavingsAccountApplicationPayload
import org.mifos.mobile.core.model.entity.accounts.savings.SavingsAccountUpdatePayload
import org.mifos.mobile.core.model.entity.accounts.savings.SavingsAccountWithdrawPayload
import org.mifos.mobile.core.model.entity.accounts.savings.SavingsWithAssociations
import org.mifos.mobile.core.model.entity.payload.TransferPayload
import org.mifos.mobile.core.model.entity.templates.account.AccountOptionsTemplate
import org.mifos.mobile.core.model.entity.templates.savings.SavingsAccountTemplate

@OptIn(InternalKtorfitApi::class)
public class _SavingAccountsListServiceImpl(
  private val _ktorfit: Ktorfit,
) : SavingAccountsListService {
  private val _helper: KtorfitConverterHelper = KtorfitConverterHelper(_ktorfit)

  override fun getSavingsWithAssociations(accountId: Long, associationType: String?): Flow<SavingsWithAssociations> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        method = HttpMethod.parse("GET")
        url{
        takeFrom(_ktorfit.baseUrl + "savingsaccounts/${"$accountId".encodeURLPath()}")
        associationType?.let{ parameter("associations", "$it") }
        } 
        }
    val _typeData = TypeData.createTypeData(
    typeInfo = typeInfo<Flow<SavingsWithAssociations>>(),
    )
    return _helper.request(_typeData,_ext)!!
  }

  override fun accountTransferTemplate(accountId: Long?, accountType: Long?): Flow<AccountOptionsTemplate> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        method = HttpMethod.parse("GET")
        url{
        takeFrom(_ktorfit.baseUrl + "accounttransfers/template")
        accountId?.let{ parameter("fromAccountId", "$it") }
        accountType?.let{ parameter("fromAccountType", "$it") }
        } 
        }
    val _typeData = TypeData.createTypeData(
    typeInfo = typeInfo<Flow<AccountOptionsTemplate>>(),
    )
    return _helper.request(_typeData,_ext)!!
  }

  override suspend fun makeTransfer(transferPayload: TransferPayload?): HttpResponse {
    val _ext: HttpRequestBuilder.() -> Unit = {
        method = HttpMethod.parse("POST")
        url{
        takeFrom(_ktorfit.baseUrl + "accounttransfers")
        }
        setBody(transferPayload) 
        }
    val _typeData = TypeData.createTypeData(
    typeInfo = typeInfo<HttpResponse>(),
    )
    return _helper.suspendRequest(_typeData,_ext)!!
  }

  override fun getSavingsAccountApplicationTemplate(clientId: Long?): Flow<SavingsAccountTemplate> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        method = HttpMethod.parse("GET")
        url{
        takeFrom(_ktorfit.baseUrl + "savingsaccounts/template")
        clientId?.let{ parameter("clientId", "$it") }
        } 
        }
    val _typeData = TypeData.createTypeData(
    typeInfo = typeInfo<Flow<SavingsAccountTemplate>>(),
    )
    return _helper.request(_typeData,_ext)!!
  }

  override fun getSavingsAccountApplicationTemplateByProduct(clientId: Long?, productId: Long?): Flow<SavingsAccountTemplate> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        method = HttpMethod.parse("GET")
        url{
        takeFrom(_ktorfit.baseUrl + "savingsaccounts/template")
        clientId?.let{ parameter("clientId", "$it") }
        productId?.let{ parameter("productId", "$it") }
        } 
        }
    val _typeData = TypeData.createTypeData(
    typeInfo = typeInfo<Flow<SavingsAccountTemplate>>(),
    )
    return _helper.request(_typeData,_ext)!!
  }

  override suspend fun submitSavingAccountApplication(payload: SavingsAccountApplicationPayload?): HttpResponse {
    val _ext: HttpRequestBuilder.() -> Unit = {
        method = HttpMethod.parse("POST")
        url{
        takeFrom(_ktorfit.baseUrl + "savingsaccounts")
        }
        setBody(payload) 
        }
    val _typeData = TypeData.createTypeData(
    typeInfo = typeInfo<HttpResponse>(),
    )
    return _helper.suspendRequest(_typeData,_ext)!!
  }

  override suspend fun updateSavingsAccountUpdate(accountsId: Long, payload: SavingsAccountUpdatePayload?): HttpResponse {
    val _ext: HttpRequestBuilder.() -> Unit = {
        method = HttpMethod.parse("PUT")
        url{
        takeFrom(_ktorfit.baseUrl + "savingsaccounts/${"$accountsId".encodeURLPath()}")
        }
        setBody(payload) 
        }
    val _typeData = TypeData.createTypeData(
    typeInfo = typeInfo<HttpResponse>(),
    )
    return _helper.suspendRequest(_typeData,_ext)!!
  }

  override suspend fun submitWithdrawSavingsAccount(savingsId: Long, payload: SavingsAccountWithdrawPayload?): HttpResponse {
    val _ext: HttpRequestBuilder.() -> Unit = {
        method = HttpMethod.parse("POST")
        url{
        takeFrom(_ktorfit.baseUrl + "savingsaccounts/${"$savingsId".encodeURLPath()}?command=withdrawnByApplicant")
        }
        setBody(payload) 
        }
    val _typeData = TypeData.createTypeData(
    typeInfo = typeInfo<HttpResponse>(),
    )
    return _helper.suspendRequest(_typeData,_ext)!!
  }

  override fun getSavingsAccountTransactionDetails(savingsId: Long, transactionId: Long): Flow<TransactionDetails> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        method = HttpMethod.parse("GET")
        url{
        takeFrom(_ktorfit.baseUrl + "savingsaccounts/${"$savingsId".encodeURLPath()}/transactions/${"$transactionId".encodeURLPath()}")
        } 
        }
    val _typeData = TypeData.createTypeData(
    typeInfo = typeInfo<Flow<TransactionDetails>>(),
    )
    return _helper.request(_typeData,_ext)!!
  }
}

public class _SavingAccountsListServiceProvider : ClassProvider<SavingAccountsListService> {
  override fun create(_ktorfit: Ktorfit): SavingAccountsListService = _SavingAccountsListServiceImpl(_ktorfit)
}

public fun Ktorfit.createSavingAccountsListService(): SavingAccountsListService = _SavingAccountsListServiceImpl(this)
